import React, { useEffect, useRef } from "react";
import HeroCareers from "./Hero";
import DrivenByResults from "./DrivenByResults";
import NowPlayers from "./NowPlayers";
import GlobalPresence from "./GlobalPresence";
import ExploreSection from "./ExploreSection";
import PrivilegeCards from "./Cards";
import EmployeeCards from "./EmployeeTestimoialCards";
import useAllowSticky from "../../utils/useAllowSticky";

function Careers() {
  // The job filters sidebar is sticky; see allowSticky.css for why the shell
  // needs this opt-in for sticky to engage at all.
  useAllowSticky();

  const exploreRef = useRef(null);
  const careerReference = useRef(null);

  useEffect(() => {
    // Land at the top of the Careers page — don't auto-scroll to the listings.
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <HeroCareers reference={exploreRef} />
      <DrivenByResults />
      <NowPlayers />
      <GlobalPresence />
      <PrivilegeCards />
      <EmployeeCards />
      <ExploreSection ref={careerReference} />
    </div>
  );
}

export default Careers;
